import { memo, useMemo, useState } from "react";
import { Button } from "primereact/button";
import { Chart } from "primereact/chart";
import ChartDataLabels from 'chartjs-plugin-datalabels';

const options = {
    maintainAspectRatio: false,
    plugins: {
        datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value) => {
                return Intl.NumberFormat("pt-BR", {
                    maximumFractionDigits: 2,
                }).format(value);
            },
            font: {
                size: 14,
                weight: 'bold',
            },
            color: "#2c3e50"
        }
    },
};

export const GraficoMetrosPorArt = memo(function GraficoMetrosPorArt({ data = [], colProp = "p-col-12", }) {

    const [col, setCol] = useState(colProp);

    const chartData = useMemo(() => {

        const labels = data.map(item => String(item.nome));
        const values = data.map(item => parseFloat(item.total_metros));

        return {
            labels,
            datasets: [
                {
                    label: "TOTAL DE METROS POR ARTIGO",
                    data: values,
                    backgroundColor: "#2ecc71"
                }
            ]
        };

    }, [data]);

    return (
        <div className={col}>
            <Button
                icon="pi pi-align-left"
                onClick={() => {
                    setCol(col === "p-col-12" ? "p-col-6" : "p-col-12");
                }}
            />

            <Chart
                data={chartData}
                height="350px"
                width="100%"
                options={options}
                plugins={[ChartDataLabels]}
                type="bar"
            />
        </div>
    );
});